import coursera from "../media/coursera.png";
import udemy from "../media/udemy.png";

export const certificates = [
  {
    title: "Meta Front-End Developer Certificate",
    platform: "Coursera",
    skills:
      "REST APIs · Responsive Web Design · Testing · Version Control · Front-End Development · JavaScript · React.js · UX/UI",
    image: coursera,
    date: "April 2023",
    credential:
      "https://www.credly.com/badges/2634d6ea-da8a-4bef-91ae-abf8b269602c/linked_in_profile",
    id: 0,
  },
  {
    title: "The Web Developer Bootcamp 2023",
    platform: "Udemy",
    skills:
      "NoSQL · Cascading Style Sheets (CSS) · REST APIs · MongoDB · Front-End Development · JavaScript · Node.js · HTML5 · Bootstrap",
    image: udemy,
    date: "Jan 2023",
    credential:
      "https://www.udemy.com/certificate/UC-4dc60a1c-cd1d-42a3-9a92-fba898877f67/",
    id: 1,
  },
  {
    title: "The Modern Javascript Bootcamp Course (2022)",
    platform: "Udemy",
    skills: "Express · Node.js · JavaScript",
    image: udemy,
    date: "Maj 2023",
    credential:
      "https://www.udemy.com/certificate/UC-245d3086-f56d-4331-b9c1-e685bf9fbc0f/",
    id: 2,
  },
  {
    title: "Cpmplete React Developer in 2023 (w/Redux, Hooks, GraphQL)",
    platform: "Udemy",
    skills: "React.js · Redux · GraphQL · React Hooks · Firebase",
    image: udemy,
    date: "Maj 2023",
    credential:
      "https://www.udemy.com/certificate/UC-e26d0f5a-5339-425f-9d0d-64c82c851be3/",
    id: 3,
  },
];
